import { render, staticRenderFns } from "./EfsMdDiseaseList.vue?vue&type=template&id=5286d6c6&scoped=true&"
import script from "./EfsMdDiseaseList.vue?vue&type=script&lang=js&"
export * from "./EfsMdDiseaseList.vue?vue&type=script&lang=js&"
import style0 from "./EfsMdDiseaseList.vue?vue&type=style&index=0&id=5286d6c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5286d6c6",
  null
  
)

export default component.exports